import { DateTime } from 'luxon'

import { MessageThread } from '../../common/validations/residentMessageTimelineSchema'

const NEW_MESSAGE_BADGE_MAX_AGE_DAYS = 14

type MessageThreadEntry = MessageThread['entries'][number]

export const getLatestMessage = (entries: MessageThreadEntry[]) =>
  entries.reduce<MessageThreadEntry | undefined>(
    (latest, entry) =>
      !latest ||
      DateTime.fromISO(entry.timestamp).toMillis() >
        DateTime.fromISO(latest.timestamp).toMillis()
        ? entry
        : latest,
    undefined
  )

export const isNewMessage = (msg: MessageThreadEntry) =>
  msg.__typename === 'OutgoingEmailMessage' &&
  !msg.isRead &&
  DateTime.fromISO(msg.timestamp) >=
    DateTime.now().minus({ days: NEW_MESSAGE_BADGE_MAX_AGE_DAYS })
